import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home";
import FindLayouts from "../pages/FindLayouts";
import CustomizeLayout from "../pages/CustomizeLayout";

// Admin
import AdminLogin from "../admin/pages/AdminLogin";
import AdminMainlayout from "../admin/components/AdminMainlayout";
import Layouts from "../admin/pages/Layouts";

const Allroutes = () => {
    return (
        <Router basename={'/inkapi'} >
            <Routes>
                <Route exact path="/" element={<MainLayout><Home /></MainLayout>} />
                <Route exact path="/find-layouts" element={<MainLayout><FindLayouts /></MainLayout>} />
                <Route exact path="/customize-layout/:id/:slug" element={<MainLayout><CustomizeLayout /></MainLayout>} />

                <Route exact path="/admin" element={<AdminLogin />} />
                <Route exact path="/admin/login" element={<AdminLogin />} />

                <Route exact path="/admin/all-layouts" element={<AdminMainlayout><Layouts /></AdminMainlayout>} />
            </Routes>
        </Router>
    )
}

export default Allroutes;